<template>
  <div class="company_module module_item company_module1">
    <div class="total-top">
      Total
      <span class="totalCls">{{total}}</span> records
    </div>

    <div class="list_resullt" v-if="lists.length">
      <div
        class="result_item"
        v-for="(item,index) of lists"
        :key="index"
        @click="searchData(item)"
        :class="{activeModuleCls:active==item.id}"
      >
        <div class="item_title">
          <span class="title">{{item.title}}</span>
          <!-- <span class="region">{{item.region}}</span> -->
        </div>
        <div class="detail" :title="item.detail">{{item.detail}}</div>
      </div>
    </div>
    <div class="list_resullt" v-else>
      <div class="noData no_data_container">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>

    <div class="page_footer clearfix">
      <!-- <p class="total_page">
        Total
        <span class="totalCls">{{total}}</span> records
      </p>-->
      <el-pagination
        :total="total"
        background
        layout="prev, pager, next"
        :current-page="patentData.page"
        :pager-count="5"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  props: ["lists", "total"],

  data() {
    return {
      active: "",
      patentData: {
        // 默认属性
        applicant: "",
        applicantionNumber: "",
        inventor: "",
        publicNumber: "",
        applicantionDate: "",
        publicDate: "",
        countries: "",
        //
        page: 1,
        rows: 10
      }
    };
  },

  mounted() {
    this.emitSearch();
  },

  methods: {
    emitSearch() {
      this.$emit("search", "patent", this.patentData);
    },

    searchData(item) {
      this.active = item.id;

      //关闭主页显示
      this.changeIndexShow(false);
      this.$router.push({
        path: "/data/SearchModule/Patent",
        query: {
          id: item.id
        }
      });
    },

    handleCurrentChange(val) {
      this.patentData.page = val;
      this.emitSearch();
    },

    ...mapMutations(["changeIndexShow"])
  }
};
</script>

<style scoped>
.detail {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.list_resullt {
  margin-top: 10px;
  height: calc(100% - 150px);
  overflow-y: auto;
  padding: 0 10px 0 0;
  margin-bottom: 10px;
}
.page_footer >>> .el-pagination {
  float: right;
}
.item_title .title {
  width: 80%;
  margin-right: 2%;
}
.region {
  color: #007bff;
  border: 1px solid #007bff;
  padding: 0px 5px;
}
</style>